import React from "react";
import BaseComponent from '../baseComponent'
import VerifyEmail from './verifyemail'
import Utils from "../../utility";

class verifyEmailPage extends BaseComponent {
    
    constructor(props) {
        super(props);
        this.state = {
            userId: ""
        }
    }

    componentDidMount() {

    }

    render() {
        const query = new URLSearchParams(this.props.location.search);
        const userId = query.get('userId')
        const ticketUrl = query.get('verifyTicket')
        return (
            <VerifyEmail data = {userId} ticket={ticketUrl}/>
        );
    }
}

export default verifyEmailPage;